import { render, staticRenderFns } from "./supplierAccountSetting.vue?vue&type=template&id=7353a232&scoped=true&"
import script from "./supplierAccountSetting.vue?vue&type=script&lang=js&"
export * from "./supplierAccountSetting.vue?vue&type=script&lang=js&"
import style0 from "./supplierAccountSetting.vue?vue&type=style&index=0&id=7353a232&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7353a232",
  null
  
)

export default component.exports